import React, { useCallback, useEffect, useReducer, useState } from "react"
import { atualizarFornecedor, obterFornecedor } from "../../../services/dadosUsuarioFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { FornecedorInicial } from "../models/fornecedorModel"
import { DadosFornecedorActionsTypes } from "./dadosFornecedorActions"
import { DadosFornecedorContext } from "./DadosFornecedorContext"
import { dadosFornecedorReducer } from "./dadosFornecedorReducer"

type DadosFornecedorContextProviderProps = {
    children: React.ReactNode
}

export function DadosFornecedorContextProvider({ children }: DadosFornecedorContextProviderProps) {
    const [fornecedor, dispatch] = useReducer(dadosFornecedorReducer, FornecedorInicial)
    const [carregando, setCarregando] = useState(false)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return

        try {
            setLoading(true)
            const response = await obterFornecedor(autorizacao)

            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar dados do fornecedor")
            } else {
                setErroCarregamento(null)
                dispatch({ type: DadosFornecedorActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar dados do fornecedor")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(
        async (novaSenha?: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return

            setCarregando(true)
            try {
                const payload = {
                    nome: fornecedor.nome,
                    email: fornecedor.email,
                    telefone: fornecedor.telefone,
                    receberEmail: fornecedor.receberEmail,
                    receberEmailPedidoExpirado: fornecedor.receberEmailPedidoExpirado,
                    receberEmailPedidoRealizado: fornecedor.receberEmailPedidoRealizado,
                    receberEmailPedidoCancelado: fornecedor.receberEmailPedidoCancelado,
                    receberEmailResumoDiario: fornecedor.receberEmailResumoDiario,
                    ...(novaSenha ? { novaSenha } : {}),
                }

                const response = await atualizarFornecedor(autorizacao, payload)

                if ("retornoErro" in response) {
                    throw new Error(response.mensagem)
                }

                dispatch({ type: DadosFornecedorActionsTypes.CARREGAR, payload: response })
            } finally {
                setCarregando(false)
            }
        },
        [fornecedor]
    )

    return (
        <DadosFornecedorContext.Provider
            value={{ fornecedor, dispatch, salvar, carregando, erroCarregamento }}
        >
            <Loading />
            {children}
        </DadosFornecedorContext.Provider>
    )
}
